<div class="counts" *ngIf="permitCounts">
  <mat-expansion-panel class="count-panel" [hideToggle]="true">
    <mat-expansion-panel-header class="header">
      <mat-panel-title class="panel-title"
        >Permits <span>{{ permitCounts.total }}</span></mat-panel-title
      >
    </mat-expansion-panel-header>
    <div class="panel-body">
      <div
        class="panel-item"
        [routerLink]="['counts/list', 'permitCounts', 'permitsRequired']"
      >
        <p class="count">Permits Required</p>
        <span>{{ permitCounts.permitsRequired }}</span>
      </div>
      <div
        class="panel-item"
        [routerLink]="['counts/list', 'permitCounts', 'permitsRequested']"
      >
        <p class="count">Permits Requested</p>
        <span>{{ permitCounts.permitsRequested }}</span>
      </div>
      <div
        class="panel-item"
        [routerLink]="['counts/list', 'permitCounts', 'permitsReceived']"
      >
        <p class="count">Permits Received</p>
        <span>{{ permitCounts.permitsReceived }}</span>
      </div>
    </div>
  </mat-expansion-panel>
</div>
